<template>
  <div>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
<!--             <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td> -->
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>Registrar Diagnóstico
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Tipo</th>
          <th scope="col">Código</th>
          <th scope="col">Nombre</th>
          <th scope="col">Observación</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="diaginter in datosPaginados" :key="diaginter.idDiagInter">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(diaginter.idDiagInter)" title="Editar">edit_square</i></td>
          <td>{{diaginter.tipo}}</td>
          <td>{{diaginter.diagnosticoCodigo}}</td>
          <td>{{diaginter.diagnosticoNombre}}</td>
          <td>{{diaginter.observacion}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteDiagInter(diaginter.idDiagInter)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form @submit.prevent>
        <div class="modal-body">
<!-- Botón Lista de Valores  Diagnostico -->
          <div class="mb-3">
            <div class="row">
              <div class="col-2">
                <label for="idDiagnostico" class="form-label"> Diagnóstico</label>
              </div>
              <div class="col-10">
                <div class="input-group">
                  <input type="text" class="form-control" id="searchTextDiag" 
                        v-model="searchTextDiag"
                        @input="filterDiagnosticos"
                        @keyup.enter="toggleDropdown"
                        placeholder="Buscar diagnóstico...">
                  <button class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          ref="dropdownButton">
                    <i class="fa fa-search"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end shadow"
                      style="max-height: 250px; overflow-y: auto; width: 100%;"
                      ref="dropdownMenu">
                    <li v-for="diagnostico in filteredDiagnosticos" :key="diagnostico.idDiagnostico">
                      <a class="dropdown-item text-truncate"
                        href="#"
                        @click="selectDiagnostico(diagnostico)"
                        :title="diagnostico.nombre">
                        {{ diagnostico.nombre }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
<!-- Botón Lista de Valores  Diagnostico -->
<!-- Botón Lista de Valores  Informe Inter -->
<!-- Botón Lista de Valores  Informe Inter -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                  <select class="form-select" id="tipo" name="tipo" v-model="datoDiagInter.tipo">
                    <option value="" disabled>Seleccione una opción</option>
                    <option value="Presuntivo">Presuntivo</option>
                    <option value="Definitivo">Definitivo</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="observacion" name="observacion" v-model="datoDiagInter.observacion" style='text-transform:uppercase' maxlength="250"></textarea>
                </div>
              </div>
            </div>
<!-- 
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idDiagInter" class="form-label">IdDiagInter</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="idDiagInter" name="idDiagInter" v-model="datoDiagInter.idDiagInter" disabled>
                </div>
                   <div class="col-2">
                    <label for="idInformeInter" class="form-label"> Informe Inter</label>
                  </div>
                  <div class="col-4">
                    <select class="form-control" id="idInformeInter" name="idInformeInter" v-model="datoDiagInter.idInformeInter">
                      <option v-for="informeInter in informeInters" :value="informeInter.idInformeInter" :key="informeInter.idInformeInter">
                        {{ informeInter.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-success" @click.prevent="guardarDiagInter" v-if="btnCrear" title="Guardar">
<span class="material-symbols-outlined align-middle" style="font-size:32px;">
  save
</span> Guardar
        </button>
        <button type="submit" class="btn btn-success" @click.prevent="guardarEditDiagInter" v-if="btnEditar" title="Actualizar">
<span class="material-symbols-outlined align-middle" style="font-size:32px;">
  update
</span> Actualizar
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  props: {
    p_idInformeInter: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      diaginters : [],
      datoDiagInter : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      diagnosticos: [],
      filteredDiagnosticos: [],
      searchTextDiag: '',
      informeInters: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchDiagnosticos()
    // this.fetchInformeInters()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.diaginters.length / this.elementosPorPagina)
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwdiaginters/idinformeinter/'+this.p_idInformeInter).then(response=>{
      this.diaginters=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.diaginters.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idDiagnostico'
        ,'tipo'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'idDiagnostico'
        ,'tipo'
        ,'observacion'
      ];
      return validarForm(this.datoDiagInter, requiredFields, requiredFieldsText);
    },
    async guardarDiagInter(){
      if(this.validarForm() === 1){
        try {
          this.datoDiagInter.idInformeInter = this.p_idInformeInter;
          await api.post('/diaginters', this.datoDiagInter)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "DiagInter creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditDiagInter(){
      if(this.validarForm() === 1){
        try {
          await api.post('/diaginters', this.datoDiagInter)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "DiagInter creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoDiagInter={}
      this.titulo   = 'Registrar Diagnóstico'
      this.btnCrear = true
      this.btnEditar= false
      this.searchTextDiag = ''
    },
    abrirModalEditar(idDiagInter){
      this.modalWindow = true
      if(idDiagInter != null){    
        api.get('/vwdiaginters/'+idDiagInter).then(resp=>{
          this.datoDiagInter = resp.data;
          this.searchTextDiag = this.datoDiagInter.diagnosticoCodigo+ ' - '+this.datoDiagInter.diagnosticoNombre;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Diagnóstico'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idDiagInter){
      if(idDiagInter != null){
        this.$router.push('/diagintermd/'+idDiagInter)
      }
    },
    async deleteDiagInter (idDiagInter) {
      try{
        await api.delete('/diaginters/'+idDiagInter)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchDiagnosticos() {
      fetch('http://localhost:8080/api/v1/vwdiagnosticos')
        .then(response => response.json())
        .then(data => {
          this.diagnosticos = data;
          this.filteredDiagnosticos = data;  // Initialize the filtered diagnosticos
        })
        .catch(error => {
          console.error('Error fetching diagnosticos:', error);
        });
    },
    filterDiagnosticos() {
      this.filteredDiagnosticos = this.diagnosticos.filter(diagnostico =>
        diagnostico.nombre.toLowerCase().includes(this.searchTextDiag.toLowerCase())
      );
    },
    selectDiagnostico(diagnostico) {
      this.datoDiagInter.idDiagnostico = diagnostico.idDiagnostico;
      this.searchTextDiag = `${diagnostico.codigo} - ${diagnostico.nombre}`;  // Display the selected diagnostico
    },
    toggleDropdown() {
      let dropdown = this.$refs.dropdownButton;
      dropdown.click();  // Simula un clic en el botón para desplegar el menú
    }
/*     fetchInformeInters() {
      fetch('http://localhost:8080/api/v1/informeinters')
        .then(response => response.json())
        .then(data => {
          this.informeInters = data;
        })
        .catch(error => {
          console.error('Error fetching informeInters:', error);
        });
    }, */
  },
}
</script>
<style src="@/assets/css/listaFiltrada02.css" scoped></style>
